// ============================================================================
// ENGLISH TRANSLATIONS - CHAPTER 7: LETTERS AND REVELATION
// ============================================================================
// Levels 79-91 (13 levels, 39 questions)

export const chapter7Translations = {
  name: "Letters and Revelation",
  description: "He who overcomes will inherit these things... Heavenly wisdom sanctifies the mind",
  
  spiritualWisdom: {
    principle: "Heavenly wisdom sanctifies the mind and gives life to the spirit",
    scripture: "If any of you lacks wisdom, let him ask God (James 1:5)",
    application: "Each apostolic letter and each vision of Revelation enriches our understanding and strengthens our hope"
  },
  
  levels: {
    79: {
      name: "Arrest in Jerusalem",
      challenge: "I am ready not only to be bound, but also to die at Jerusalem...",
      easy: {
        question: "Where was Paul arrested during his final visit?",
        options: ["Antioch", "Ephesus", "Jerusalem", "Corinth"],
        hint: "The holy city that often persecuted prophets",
        funFact: "🏛️ Jerusalem: place of glory and suffering for all God's servants!"
      },
      medium: {
        question: "What was Paul accused of by the Jews?",
        options: [
          "Stealing from the Temple",
          "Defiling the Temple by bringing in Gentiles",
          "Blasphemy against Moses",
          "Rebellion against Rome"
        ],
        hint: "Accusation related to the Gospel's universality",
        funFact: "⛪ Irony: Paul accused of defiling the Temple he deeply honored!"
      },
      hard: {
        question: "How did Paul transform his captivity into opportunity?",
        options: [
          "He escaped",
          "He witnessed before authorities and wrote his epistles",
          "He remained silent",
          "He negotiated his release"
        ],
        hint: "It's about transforming trials into testimony",
        funFact: "⛓️ Physical chains, spiritual freedom - powerful testimony of faith!"
      }
    },
    
    80: {
      name: "Before Governor Felix",
      challenge: "I do my best to maintain always a blameless conscience...",
      easy: {
        question: "Who was the Roman governor who kept Paul imprisoned?",
        options: ["Pilate", "Felix", "Festus", "Agrippa"],
        hint: "The one who hoped for a bribe",
        funFact: "💰 Felix kept Paul imprisoned hoping for money - corruption in high places!"
      },
      medium: {
        question: "What did Paul preach about that made Felix afraid?",
        options: [
          "God's love",
          "Righteousness, self-control, and coming judgment",
          "Miracles and healings",
          "Jewish customs"
        ],
        hint: "Topics that convicted the corrupt governor",
        funFact: "😰 Gospel truth makes even powerful people tremble with conviction!"
      },
      hard: {
        question: "Why did Felix postpone decision despite being convinced?",
        options: [
          "He was busy",
          "Convenience vs. conviction - he loved his sin more than truth",
          "He needed more evidence",
          "He feared the Jews"
        ],
        hint: "It's about choosing convenience over conscience",
        funFact: "⏰ 'A more convenient time' that never came - dangerous procrastination!"
      }
    },

    81: {
      name: "Appeal to Caesar",
      challenge: "I appeal to Caesar!",
      easy: {
        question: "To whom did Paul appeal when facing unjust trial?",
        options: ["The Sanhedrin", "Caesar", "King Agrippa", "The people"],
        hint: "The Roman Emperor",
        funFact: "👑 Roman citizenship gave Paul access to the highest court in the empire!"
      },
      medium: {
        question: "Why was Paul's appeal strategically brilliant?",
        options: [
          "It guaranteed freedom",
          "It brought the Gospel to Rome's highest levels",
          "It avoided Jewish courts",
          "It was cheaper"
        ],
        hint: "Divine strategy to reach the capital of the world",
        funFact: "🏛️ God uses legal system to get Paul to Rome - sovereign planning!"
      },
      hard: {
        question: "How does Paul's appeal demonstrate faith in God's sovereignty?",
        options: [
          "He trusted in Roman justice",
          "He believed God would use even legal proceedings for Gospel advancement",
          "He gave up on divine help",
          "He preferred human courts"
        ],
        hint: "It's about seeing God's hand in all circumstances",
        funFact: "⚖️ Using earthly systems while trusting heavenly purposes!"
      }
    },

    82: {
      name: "Shipwreck on Malta",
      challenge: "Do not be afraid, Paul; you must stand before Caesar...",
      easy: {
        question: "On which island was Paul shipwrecked?",
        options: ["Crete", "Cyprus", "Malta", "Sicily"],
        hint: "A small Mediterranean island",
        funFact: "🏝️ Malta becomes unexpected mission field - God's detours have purpose!"
      },
      medium: {
        question: "How did Paul encourage everyone during the storm?",
        options: [
          "He told jokes",
          "He shared an angel's message that all would be saved",
          "He took command of the ship",
          "He remained silent"
        ],
        hint: "Divine revelation brought hope to desperate people",
        funFact: "👼 Paul's faith stabilizes 276 panicking people - leadership through faith!"
      },
      hard: {
        question: "What does this shipwreck teach about God's protection?",
        options: [
          "Christians are immune from danger",
          "God protects for His purposes even through trials",
          "Faith prevents all accidents",
          "Paul had special immunity"
        ],
        hint: "It's about protection through, not from, difficulties",
        funFact: "🚢 Shipwreck + snake bite + healing ministry = God's perfect storm of witness!"
      }
    },

    83: {
      name: "Paul in Rome",
      challenge: "He welcomed all who came to him, preaching the kingdom of God...",
      easy: {
        question: "How long was Paul under house arrest in Rome?",
        options: ["1 year", "2 years", "3 years", "5 years"],
        hint: "Two full years of open ministry",
        funFact: "🏠 House arrest becomes Bible college - teaching all who came!"
      },
      medium: {
        question: "What did Paul do during his Roman imprisonment?",
        options: [
          "He rested quietly",
          "He preached boldly and wrote epistles",
          "He planned his legal defense",
          "He complained about his situation"
        ],
        hint: "Continued ministry despite chains",
        funFact: "✍️ Prison letters become Scripture - eternal impact from temporary chains!"
      },
      hard: {
        question: "How did Paul's imprisonment advance the Gospel?",
        options: [
          "It didn't help at all",
          "His chains encouraged other believers and reached Caesar's household",
          "He converted his guards only",
          "It delayed the Gospel"
        ],
        hint: "It's about God's ability to use any circumstance",
        funFact: "⛓️ 'My chains have advanced the Gospel' - victory through suffering!"
      }
    },

    84: {
      name: "Letter to the Romans",
      challenge: "I am not ashamed of the Gospel, for it is the power of God...",
      easy: {
        question: "What is Paul not ashamed of?",
        options: ["His chains", "The Gospel", "His past", "His weakness"],
        hint: "The message that transforms lives",
        funFact: "💪 Gospel = dynamite of God - explosive power to save and transform!"
      },
      medium: {
        question: "How are we justified before God according to Romans?",
        options: [
          "By good works",
          "By faith alone",
          "By religious ceremonies", 
          "By birth"
        ],
        hint: "The foundation of Protestant Reformation",
        funFact: "⚖️ Justification by faith revolutionized Christianity and history!"
      },
      hard: {
        question: "What is the central theme of Romans?",
        options: [
          "Church organization",
          "God's righteousness revealed through faith for all people",
          "End times prophecy",
          "Christian behavior"
        ],
        hint: "It's about God's perfect solution to human sin",
        funFact: "📜 Romans = Gospel masterpiece - most systematic presentation of salvation!"
      }
    },

    85: {
      name: "Letters to Corinth",
      challenge: "Love is patient, love is kind...",
      easy: {
        question: "What is the greatest of faith, hope, and love?",
        options: ["Faith", "Hope", "Love", "All equal"],
        hint: "The one that lasts forever",
        funFact: "❤️ Love chapter (1 Cor 13) - most quoted wedding passage in history!"
      },
      medium: {
        question: "What problem was Paul addressing in 1 Corinthians?",
        options: [
          "Lack of money",
          "Divisions and spiritual immaturity",
          "Persecution",
          "False teaching only"
        ],
        hint: "Unity issues and growing in Christ",
        funFact: "🍼 Corinthians were spiritual babies needing milk, not meat - growth needed!"
      },
      hard: {
        question: "How does Paul's approach to church problems help us today?",
        options: [
          "Avoid confrontation",
          "Address issues with truth and love for restoration",
          "Ignore problems",
          "Split the church"
        ],
        hint: "It's about redemptive discipline with love",
        funFact: "💊 Painful medicine of truth administered with loving hands!"
      }
    },

    86: {
      name: "Letters to the Galatians",
      challenge: "It is for freedom that Christ has set us free...",
      easy: {
        question: "What were the Galatians trying to add to faith for salvation?",
        options: ["Baptism", "Circumcision", "Good works", "Church attendance"],
        hint: "Jewish ritual requirement",
        funFact: "✂️ Circumcision controversy threatened Gospel of grace with works!"
      },
      medium: {
        question: "What did Paul say about adding works to faith?",
        options: [
          "It's helpful",
          "It nullifies grace and makes Christ's death meaningless",
          "It's optional", 
          "It shows sincerity"
        ],
        hint: "Grace plus works equals no grace at all",
        funFact: "🚫 Adding anything to grace destroys grace - all or nothing!"
      },
      hard: {
        question: "What is Christian freedom according to Galatians?",
        options: [
          "License to sin",
          "Freedom from law's condemnation to serve in love",
          "Political liberty",
          "Freedom from responsibility"
        ],
        hint: "It's about liberation for loving service",
        funFact: "🕊️ True freedom = slavery to sin broken, heart free to love and serve!"
      }
    },

    87: {
      name: "Prison Epistles",
      challenge: "I can do all things through Christ who strengthens me...",
      easy: {
        question: "Which letter contains 'I can do all things through Christ'?",
        options: ["Ephesians", "Philippians", "Colossians", "Philemon"],
        hint: "The joy letter written from prison",
        funFact: "😊 Philippians = joy from jail - circumstances don't determine happiness!"
      },
      medium: {
        question: "What is the main theme of Ephesians?",
        options: [
          "Church discipline",
          "The Church as Christ's body",
          "End times",
          "Personal conduct"
        ],
        hint: "Unity and identity in Christ",
        funFact: "🏗️ Ephesians = Church blueprint - God's eternal purpose in Christ!"
      },
      hard: {
        question: "How do the prison epistles show Paul's spiritual maturity?",
        options: [
          "He complains about his situation",
          "He finds joy and purpose even in suffering",
          "He becomes bitter",
          "He gives up ministry"
        ],
        hint: "It's about perspective transformation through faith",
        funFact: "🎭 Prison becomes pulpit - chains become credentials for ministry!"
      }
    },

    88: {
      name: "Pastoral Epistles",
      challenge: "Fight the good fight, finish the race, keep the faith...",
      easy: {
        question: "Who were Paul's letters to Timothy and Titus written for?",
        options: [
          "All Christians",
          "Young pastors and church leaders",
          "Missionaries only",
          "Married couples"
        ],
        hint: "Instructions for church leadership",
        funFact: "👨‍🏫 Pastoral letters = leadership manual for young ministers!"
      },
      medium: {
        question: "What does Paul say Scripture is useful for?",
        options: [
          "Teaching only",
          "Teaching, rebuking, correcting, training in righteousness",
          "Historical interest",
          "Intellectual study"
        ],
        hint: "Four-fold purpose of God's Word",
        funFact: "📖 Scripture = complete tool kit for spiritual formation and ministry!"
      },
      hard: {
        question: "What qualities should church leaders have according to Paul?",
        options: [
          "Wealth and education",
          "Spiritual maturity, good reputation, and proven character",
          "Popularity and charisma",
          "Youth and energy"
        ],
        hint: "It's about character over credentials",
        funFact: "👑 Leadership = servant character, not worldly qualifications!"
      }
    },

    89: {
      name: "The Letter of James",
      challenge: "Faith without works is dead...",
      easy: {
        question: "According to James, what proves genuine faith?",
        options: ["Emotions", "Works", "Knowledge", "Attendance"],
        hint: "Actions demonstrate reality of belief",
        funFact: "🌳 Faith = tree, works = fruit - you know the tree by its fruit!"
      },
      medium: {
        question: "What does James say about controlling the tongue?",
        options: [
          "It's easy",
          "It's impossible to tame",
          "Only some people need to",
          "It's not important"
        ],
        hint: "Small member with great power for good or evil",
        funFact: "👅 Tongue = small rudder steering life's ship - immense influence!"
      },
      hard: {
        question: "How does James complement Paul's teaching on faith?",
        options: [
          "They contradict each other",
          "James shows what saving faith looks like in action",
          "James disagrees with Paul",
          "They address different people"
        ],
        hint: "It's about faith's visible expression, not salvation's basis",
        funFact: "⚖️ Paul = faith saves us; James = saving faith shows itself!"
      }
    },

    90: {
      name: "Letters of Peter",
      challenge: "Cast all your anxiety on him because he cares for you...",
      easy: {
        question: "What should we do with our worries according to Peter?",
        options: [
          "Keep them to ourselves",
          "Cast them on God",
          "Share with friends only",
          "Ignore them"
        ],
        hint: "God wants to carry our burdens",
        funFact: "🎒 God = divine burden-bearer - He wants to carry what weighs us down!"
      },
      medium: {
        question: "How should Christians respond to suffering according to Peter?",
        options: [
          "Complain bitterly",
          "Rejoice that they share Christ's sufferings",
          "Seek revenge",
          "Give up faith"
        ],
        hint: "Suffering connects us to Christ's experience",
        funFact: "✝️ Suffering + faithfulness = sharing Christ's glory - eternal perspective!"
      },
      hard: {
        question: "What makes Peter's teaching on suffering especially powerful?",
        options: [
          "He never suffered",
          "He had failed Jesus but experienced restoration and forgiveness",
          "He was naturally brave",
          "He avoided persecution"
        ],
        hint: "It's about credibility through personal experience",
        funFact: "🔥 Peter = from denier to martyr - grace transforms cowards into heroes!"
      }
    },

    91: {
      name: "The Revelation of John",
      challenge: "Behold, I am coming soon! Blessed is he who keeps the words of this prophecy...",
      easy: {
        question: "To how many churches did John write in Revelation?",
        options: ["5", "7", "10", "12"],
        hint: "The number of completion",
        funFact: "💌 Seven churches = complete picture of church conditions through history!"
      },
      medium: {
        question: "What is the central message of Revelation?",
        options: [
          "Fear the end times",
          "Christ wins and His people triumph",
          "Predict exact dates",
          "Condemn the world"
        ],
        hint: "Victory assured for those who overcome",
        funFact: "👑 Revelation = victory book - Christ conquers, church triumphs!"
      },
      hard: {
        question: "How should Revelation affect Christian living today?",
        options: [
          "Create fear and anxiety",
          "Inspire hope, faithfulness, and readiness for Christ's return",
          "Encourage withdrawal from world",
          "Promote date-setting"
        ],
        hint: "It's about hope and holy living in anticipation",
        funFact: "⏰ 'Behold, I come quickly' - live ready for His appearing!"
      }
    }
  }
};

export default chapter7Translations;